import { ViewType, FieldType } from "@framework/core/Enums";

  export class FormBuilderControlType {
    viewType: ViewType;

    constructor(fieldType: FieldType, metadataDataTypeId: string) {
      if (!metadataDataTypeId) {
        switch (+fieldType) {
          case FieldType.String:
            this.viewType = ViewType.String;
            break;
          case FieldType.Int:
            this.viewType = ViewType.IntNoFormat;
            break;
          case FieldType.Bool:
            this.viewType = ViewType.CheckBox;
            break;
          case FieldType.DateTime:
            this.viewType = ViewType.DateTime;
            break;
          case FieldType.Enum:
            this.viewType = ViewType.Dropdown;
            break;
          case FieldType.Password:
            this.viewType = ViewType.Password;
            break;
          case FieldType.Float:
            this.viewType = ViewType.Float;
            break;
          case FieldType.Text:
            this.viewType = ViewType.Text;
            break;
          case FieldType.YesNo:
             this.viewType = ViewType.YesNo;
            break;
          case FieldType.Byte:
            this.viewType = ViewType.YesNo;
            break;
          case FieldType.Time:
            this.viewType = ViewType.Time;
            break;
          case FieldType.File:
            this.viewType = ViewType.File;
            break;
          case FieldType.Guid:
            this.viewType = ViewType.Dropdown;
            break;
          case FieldType.Button:
            this.viewType = ViewType.Button;
            break;
          case FieldType.LargeButton:
            this.viewType = ViewType.LargeButton;
            break;
          case FieldType.Popup:
            this.viewType = ViewType.Popup;
            break;
          case FieldType.BloodPressure:
            this.viewType = ViewType.StringMask;
            break;
          case FieldType.MultiSelect:
            this.viewType = ViewType.MultiSelect;
            break;
          case FieldType.WacomSignature:
            this.viewType = ViewType.Signature;
            break;
          //case FieldType.Grid:
          //  //
          //  break;
          case FieldType.Label:
            this.viewType = ViewType.Label;
            break;
          //case FieldType.YesNoIgnore:
          //  //
          //  break;
          default:
            this.viewType = ViewType.String;
        }
      } else {
        switch (metadataDataTypeId) {
          case 'b8e5013a-6dcd-40f8-85f3-1849bc8fdff9': this.viewType = ViewType.String; break;
          case 'e2c8e16e-d7f7-4f47-a4f4-287ae1083ce0': this.viewType = ViewType.Dropdown; break;
          case '0121f795-0a8e-4364-b8cf-3414b4b55b03': this.viewType = ViewType.Text; break;
          case '7ffbf7c5-fe79-4e73-b9f5-39893e35a450': this.viewType = ViewType.CheckBox; break;
          case 'eb5ba210-9349-4f76-bdde-3d8fb064fcb2': this.viewType = ViewType.IntNoFormat; break;
          case '97495c4e-e501-4d12-970d-4779ecf553d1': this.viewType = ViewType.DateFrequency; break;
          case '5e0fba0d-00c5-45e9-8295-479d28c4c67d': this.viewType = ViewType.InputMask; break;
          case '9a6f8f37-00d1-411b-b8af-4c1a4ee743b4': this.viewType = ViewType.Int; break;
          case '33e46fce-6e7a-4048-a4e1-4ee4b0b48f04': this.viewType = ViewType.Slider; break;
          case '89a50c9b-e902-4088-bf4f-5d30efaf96c2': this.viewType = ViewType.MultiSelect; break;
          case 'a8108a0b-c5ea-46fa-8536-6e674b354737': this.viewType = ViewType.Time; break;
          case 'bea29770-a358-4bff-8357-6f7ea992f8b9': this.viewType = ViewType.Pictures; break;
          case '02d58722-fc60-43fb-bb2d-7040ea05d82b': this.viewType = ViewType.TimeEstimate; break;
          case '1579d22c-42e9-4f8c-a996-729d78c06e4a': this.viewType = ViewType.Document; break;
          case 'a10941ce-77ca-4975-8e86-7760bdbdc27a': this.viewType = ViewType.ContainerLayoutConfig; break;
          case '8e8a2d0c-9421-4856-987a-7d498fb8ebc1': this.viewType = ViewType.QRScanner; break;
          case 'a8dfba66-82bb-4f6a-a193-81247bf935b6': this.viewType = ViewType.Date; break;
          case '5d1f4969-2a71-4727-b6ff-9c8614c2e5e2': this.viewType = ViewType.Float; break;
          case '12d3fa39-2d99-4c15-9486-ab3ceac82ea6': this.viewType = ViewType.Switch; break;
          case '866e04c8-bdef-4aa1-bfc7-b303db29f3ae': this.viewType = ViewType.DateTime; break;
          case '38a395c8-fd52-483a-9e8f-f57938a5b4fd': this.viewType = ViewType.RadioButton; break;
          case 'b6f0f5ff-9dff-49a0-b8fe-f5f092ed6253': this.viewType = ViewType.AutoComplete; break;
          case 'ffe021b4-8e01-4027-a5d9-fa709b173e3a': this.viewType = ViewType.File; break;
          case 'b07bc8a2-5851-4cce-b7dc-fe2a8321085a': this.viewType = ViewType.Signature; break;
        }
      }
    }
  }
